import ImgLinkBtn from "./ImgLinkBtn";

export default function LinksBar(): JSX.Element {
  return (
    <div className="h-fit p-5 m-1 top:[-5%] flex flex-col gap-5 rounded-xl border-gray border-2">
      <ImgLinkBtn
        external={true}
        link={"https://www.linkedin.com/in/jun-wei-huang/"}
        src={"/res/svgs/linkedin.svg"}
      />
      <ImgLinkBtn
        external={true}
        link={"https://github.com/jun-w-huang"}
        src={"/res/svgs/github.svg"}
      />
      <ImgLinkBtn
        external={true}
        link={"mailto: huang.junw@northeastern.edu"}
        src={"/res/svgs/email.svg"}
      />
    </div>
  );
}
